// React
import React, { useState } from 'react';

// Material UI
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { makeStyles, darken } from '@material-ui/core/styles';

// Utils
import moment from 'moment/moment';
import request from '../../../utils/request';
import { NotificationManager } from 'react-notifications';

// Components
import RaffleHistory from './RaffleHistory';
import DatetimeRangePicker from '../../DateTimePicker';
import ConfirmationModal from '../../ConfirmationDialog';

// Constants
import { BACKEND_URL, DATE_FORMAT } from '../../../constants';

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '100%',
    maxHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    alignItems: 'center'
  },
  raffleBtn: {
    background: theme.statusPalette.active,

    '&:hover': {
      background: darken(theme.statusPalette.active, 0.2)
    }
  },
  deleteBtn: {
    background: theme.statusPalette.inactive,

    '&:hover': {
      background: darken(theme.statusPalette.inactive, 0.2)
    }
  }
}));

const Raffle = () => {
  const classes = useStyles();

  const [loadCount, setLoadCount] = useState(0);
  const [confirmDeleteProps, setConfirmDeleteProps] = useState(null);

  const [startDate, setStartDate] = useState(moment().subtract(30, 'days').startOf('day'));
  const [endDate, setEndDate] = useState(moment().endOf('day'));

  async function handleGenerateClick() {
    try {
      await request(
        `${BACKEND_URL}/promotions/pick_winner?q_created_at_start=${startDate.toISOString()}&q_created_at_end=${endDate.toISOString()}`,
        {
          method: 'GET'
        }
      );

      setLoadCount((oldValue) => oldValue + 1);

      NotificationManager.success(`Client extras cu succes!`);
    } catch (ex) {
      NotificationManager.error(`A apărut o eroare: ${ex.message}`);
    }
  }

  async function deleteHistory() {
    try {
      await request(`${BACKEND_URL}/promotions/winners`, {
        method: 'DELETE'
      });

      setLoadCount((oldValue) => oldValue + 1);
      setConfirmDeleteProps(null);

      NotificationManager.success(`Istoric șters cu succes!`);
    } catch (ex) {
      NotificationManager.error(`A apărut o eroare: ${ex.message}`);
    }
  }

  return (
    <Paper classes={{ root: classes.paper }}>
      <Box display="grid" gridGap={10} pb={4} style={{ placeItems: 'center' }}>
        <Box>
          <DatetimeRangePicker
            timeFormat="HH:mm"
            dateFormat={DATE_FORMAT}
            defaultStartDate={startDate}
            startDate={startDate}
            defaultEndDate={endDate}
            endDate={endDate}
            startInputProps={{ placeholder: 'De la...' }}
            endInputProps={{ placeholder: 'până la...' }}
            onChange={({ start, end }) => {
              setStartDate(start);
              setEndDate(end);
            }}
          />
        </Box>

        <Box display="flex" style={{ gap: 10 }}>
          <Button classes={{ root: classes.raffleBtn }} onClick={handleGenerateClick}>
            Extrage client
          </Button>

          <Button
            classes={{ root: classes.deleteBtn }}
            onClick={() =>
              setConfirmDeleteProps({
                confirmCallback: deleteHistory,
                message: `Ești sigur?`
              })
            }
          >
            Șterge istoricul extragerilor
          </Button>
        </Box>
      </Box>

      <RaffleHistory loadCount={loadCount} />

      {confirmDeleteProps && <ConfirmationModal onClose={() => setConfirmDeleteProps(null)} {...confirmDeleteProps} />}
    </Paper>
  );
};

export default Raffle;
